/**
 * lib-integrations
 *
 * Adapptio Integration library.
 *
 * @package lib-integrations
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TDecoratorIntegrationDefinition } from "./IIntegrationDefinition";

/**
 * Integration decorator
 *
 * @param integrationDefinition Integration definition
 * @returns
 */
export function StoreDefinition(integrationDefinition: TDecoratorIntegrationDefinition) {
	// eslint-disable-next-line @typescript-eslint/ban-types
	const constructorFunction = function (constructor: Function) {
		constructor.prototype.integrationDefinition = integrationDefinition;
	};

	return constructorFunction;
}
